import { useMovieContext } from "../context/MovieContext";
import "../css/Favorites.css";
import MovieCard from "../Component/MovieCard";
import Movie from "../Component/Movie";

const Favorites = () => {
  const { favorites } = useMovieContext();

  if (favorites.length > 0) {
    return (
      <div className="favorites1">
        <h2>Your Favorites Movies</h2>
        <div className="movies-grid">
          {favorites.map((movie) => (
            <MovieCard movie={movie} key={movie.id} />
          ))}
        </div>
      </div>
    );
  } else {
    return (
      <div className="favorites-empty">
        <h2>No Favoties movies </h2>
        <p>Start adding movies to show in the favorites section </p>
        <Movie />
      </div>
    );
  }
};

export default Favorites;
